import { writable } from 'svelte/store'
import type { SharePageDto } from './share-page.dto'
import type { AppNotification } from '../../modules/notificationsApi/notification'

export const action = writable<ActionButtonInterface>(null)
export const selectedPersonQuery = writable(null)
export const popoverIndex = writable(1000)
export const isFullscreen = writable(false)
export const pushAct = writable<{ act: string; date: Date; value: string }>(null)
export const posCashier = writable(null)
export const printerParams = writable<SharePageDto>(null)
export const notifications = writable<AppNotification[]>([])
// comando silencioso recebido via SSE (canal de notificações) — nunca aparece no sino, é só um sinal
// pra componentes reagirem programaticamente. Store dedicado, separado do pushAct (que é o mesmo
// conceito só que vindo do canal FCM) pra não misturar 'act' de canais diferentes.
export const sseCommand = writable<{ act: string; value: any; date: Date }>(null)
// visibilidade da barra de navegação inferior do mobile (template-mobile.svelte), que some ao rolar.
// Exposta para quem flutua acima dela acompanhar — ex.: o botão "Agendar" da agenda.
export const mobileBarVisible = writable(true)

// quantas camadas cobrem a tela inteira neste momento (no mobile: a lista de um select ou de uma
// busca, que ocupa tudo). Quem está embaixo precisa saber: um popover escondido atrás de uma dessas
// camadas não pode ser arrastado para fechar — o dedo está na camada de cima, não nele.
export const fullscreenLayers = writable(0)
